// extracted by mini-css-extract-plugin
export var accent = "_bi-4";
export var add = "_bi-j";
export var addIcon = "_bi-k";
export var deleteIcon = "_bi-i";
export var disabled = "_bi-9";
export var ellipsis = "_bi-f";
export var error = "_bi-3";
export var form = "_bi-5";
export var hideFocus = "_bi-2";
export var icon = "_bi-7";
export var input = "_bi-e";
export var listItem = "_bi-h";
export var mediumHeight = "_bi-b";
export var noBorder = "_bi-8";
export var noRadius = "_bi-1";
export var shortHeight = "_bi-a";
export var tallHeight = "_bi-c";
export var textInput = "_bi-0";
export var vertical = "_bi-g";
export var veryTallHeight = "_bi-d";
export var widget = "_bi-6";